import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';


class ErrorPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        
        }
    }

    render() {
        return (
           <div className="bg-right">
                <MetaTags>
                    <title>Error 404</title>
                    <meta name="description" content="Some description." />
                    <meta property="og:title" content="MyApp" />
                    <meta property="og:image" content="path/to/image.jpg" />
                </MetaTags>               
                <Header props={this.props}/>
                    <div className="body-wrapper">                  
                        <div className="container" >
                            <div className="main-content">
                                <div className="row">
                               		<h2>Error 404 Page Not Found</h2>
                                </div>
                            </div>
                        </div>
                    </div>              
                <Footer/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
    };
}
export default withRouter(connect(mapStateToProps, {
})(ErrorPage));


// WEBPACK FOOTER //
// ./src/components/Inc/Error404.js